import { getConfig } from "../config.mjs";
function getExpandedShorthands(props) {
  const shorthands = getConfig().shorthands;
  if (!shorthands) return props;
  const res = {};
  for (const key in props) res[shorthands[key] || key] = props[key];
  return res;
}
function getExpandedShorthand(propKey, props) {
  const shorthands = getConfig().inverseShorthands;
  return props[propKey] ?? props[shorthands[propKey]];
}
export { getExpandedShorthand, getExpandedShorthands };
//# sourceMappingURL=getExpandedShorthands.mjs.map
